// Category images come from Unsplash (see backend/seed_data.py) and already support `w`/`q`
// query params for server-side resizing — we just need to ask for a size that matches how the
// image is actually displayed instead of loading whatever the API happens to return.
function optimize(src, width) {
  if (!src || !src.startsWith("https://images.unsplash.com/")) return src;
  try {
    const url = new URL(src);
    url.searchParams.set("w", String(width));
    url.searchParams.set("q", "70");
    url.searchParams.set("auto", "format");
    return url.toString();
  } catch {
    return src;
  }
}

export default function CategoryImage({ src, alt, width = 480, className }) {
  const optimized = optimize(src || "/plant-placeholder.png", width);
  return (
    <img
      src={optimized}
      alt={alt}
      loading="lazy"
      decoding="async"
      width={width}
      className={className}
    />
  );
}
